/* ============================================================
   Sundays Galerrie — Countdown Timer
   ============================================================ */

(function () {
  'use strict';

  function initCountdown() {
    var el = document.getElementById('countdown');
    if (!el) return;

    var targetStr = el.getAttribute('data-target');
    if (!targetStr) return;

    var targetDate = new Date(targetStr).getTime();
    if (isNaN(targetDate)) return;

    var daysEl  = document.getElementById('countdown-days');
    var hoursEl = document.getElementById('countdown-hours');
    var minsEl  = document.getElementById('countdown-mins');
    var secsEl  = document.getElementById('countdown-secs');
    var postText = document.getElementById('announcement-post-text');

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function showExpired() {
      el.style.display = 'none';
      if (postText) {
        postText.style.display = 'inline';
        postText.classList.add('announcement-bar__pulse');
      }
    }

    function tick() {
      var now      = Date.now();
      var distance = targetDate - now;

      if (distance <= 0) {
        showExpired();
        clearInterval(timer);
        return;
      }

      var days  = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var mins  = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var secs  = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl)  daysEl.textContent  = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl)  minsEl.textContent  = pad(mins);
      if (secsEl)  secsEl.textContent  = pad(secs);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    initCountdown();
  }
})();
